export interface CountryContextUrl {
  experiences?: string;
  terms?: string;
  privacy?: string;
}

export interface CountryContextPhone {
  whatsapp?: string;
  callcenter?: string;
}

// TODO: Complete URLs and Phones for VEN and ECU when available

export const Country_Context_Url: Record<string, CountryContextUrl> = {
  BRA: {
    experiences: "https://www.ford.com.br/minhas-experiencias-ford/",
    terms: "https://www.fordpass.com/content/ford_com/fp_app/pt_br/terms.html",
    privacy: "https://www.ford.com.br/politica-de-privacidade/",
  },
  ARG: {
    experiences: "https://www.ford.com.ar/mis-experiencias-ford/",
    terms: "https://www.ford.com.ar/politicas/",
    privacy: "https://www.ford.com.ar/politicas/",
  },
  COL: {
    experiences: "https://www.ford.com.co/experiencias-ford/",
    terms: "https://www.ford.com.co/copyright/",
    privacy: "https://www.ford.com.co/privacidad-vehiculos-conectados/",
  },
  CHL: {
    experiences: "https://www.ford.cl/mis-experiencias/",
    terms: "https://www.ford.cl/politica-de-privacidad/",
    privacy: "https://www.ford.cl/politica-de-privacidad/",
  },
  PER: {
    experiences: "https://www.ford.pe/mis-experiencias-ford/",
    terms: "https://www.ford.pe/terminos-condiciones/",
    privacy: "https://www.ford.pe/politicas-de-privacidad/",
  },
  VEN: {
    experiences: "",
    terms: "",
    privacy: "",
  },
  ECU: {
    experiences: "",
    terms: "",
    privacy: "",
  }
};

export const Country_Context_Phone: Record<string, CountryContextPhone> = {
  BRA: {
    whatsapp: "+55 11 4200 3303",
    callcenter: "0800 202 4191",
  },
  ARG: {
    whatsapp: "+54 9 11 3590 9236",
    callcenter: "0800 122 7277",
  },
  COL: {
    whatsapp: "+57 1 485 0849",
    callcenter: "+57 01 800 519 0713",
  },
  CHL: {
    whatsapp: "+56 9 9400 3891",
    callcenter: "+56 800 004 502",
  },
  PER: {
    whatsapp: "+51 955 721 111",
    callcenter: "+51 0 800 56430",
  },
  VEN: {
    whatsapp: "",
    callcenter: "",
  },
  ECU: {
    whatsapp: "",
    callcenter: "",
  }
}
  